import {useTranslation} from 'react-i18next'
import {formatPercent} from '../../../../../../../shared/numberFormat'
import {parseImageQuality} from '../../Images/Services/imageLayerPayload'

const ImageQualityWarning = ({headers, showStatisticsNotice = false}) => {
  const {t} = useTranslation()
  const quality = parseImageQuality(headers)
  if (!quality) return null
  return (
    <div className='gis-map-legend__quality-warning' role='note'>
      <p>{quality.conditions.map(({label, percentage}) =>
        `${t(`images:quality.${label}`)}: ${formatPercent(percentage)}`
      ).join(' · ')}</p>
      <p>{t('images:quality.display_notice')}</p>
      {showStatisticsNotice && quality.statisticsPolicy === 'clear_pixels_only' &&
        <p>{t('images:quality.analysis_notice')}</p>}
    </div>
  )
}

export default ImageQualityWarning
